// Renamed from LandingPageBold.js
import React from 'react';
import LandingPageBold from './LandingPageBold';

const BetterSleep = () => {
  return <LandingPageBold />;
};

export default BetterSleep;
